import React from "react";
import {
  tonicsFor,
  levelOf,
  MASTERY_MAX,
  MIX_KEY,
} from "../../lib/numberSenseV2";
import { Icon, Keys } from "../numberSenseUi";

/* ============================================================
   Number Sense v2 — pick the key to drill a scale type in. A grid
   of 12 tonic chips (circle-of-fifths order), each showing its 0–5
   level as pips (a trophy once crowned), plus "surprise me" and the
   all-keys "mix it up" session. Tapping a chip starts the drill —
   the fast Duolingo-style loop is the point.
   ============================================================ */

const LevelPips = ({ level }) => {
  if (level >= MASTERY_MAX)
    return (
      <span className="v2-key-crown">
        <Icon name="trophy" />
      </span>
    );
  return (
    <span className="v2-key-pips" aria-label={`level ${level} of ${MASTERY_MAX}`}>
      {Array.from({ length: MASTERY_MAX }, (_, i) => (
        <i key={i} className={i < level ? "on" : ""} />
      ))}
    </span>
  );
};

const KeyScreen = ({ type, mastery, onPick, onClose }) => {
  const tonics = tonicsFor(type);
  const surprise = () =>
    onPick(tonics[Math.floor(Math.random() * tonics.length)].name);

  return (
    <div className="ns-root">
      <div className="ns-app">
        <div className="subbar">
          <button className="iconbtn" onClick={onClose} aria-label="back">
            <Icon name="back" />
          </button>
          <div className="subbar-title">drill: {type.title}</div>
        </div>
        <div className="scroll">
          <div className="hero v2-key-hero">
            <p>
              same recipe, different starting note — pick where <b>1</b> lives
              today.
            </p>
          </div>
          <div className="v2-keys">
            {tonics.map((t) => (
              <button
                className="v2-key-chip"
                key={t.name}
                onClick={() => onPick(t.name)}
              >
                <b className="mono">{t.name}</b>
                <LevelPips level={levelOf(mastery, type.id, t.name)} />
              </button>
            ))}
          </div>
          <button className="continue-card v2-mix-card" onClick={surprise}>
            <div className="ic">
              <Icon name="play" />
            </div>
            <div className="txt">
              <div className="kicker">surprise me</div>
              <div className="ttl">random key</div>
              <div className="sub">let the dice pick the tonic</div>
            </div>
            <span className="chev">›</span>
          </button>
          <button
            className="continue-card v2-mix-card"
            onClick={() => onPick(MIX_KEY)}
          >
            <div className="ic">
              <Icon name="grid" />
            </div>
            <div className="txt">
              <div className="kicker">mix it up</div>
              <div className="ttl">all keys, one drill</div>
              <div className="sub">every question rolls a fresh tonic</div>
            </div>
            <span className="chev">›</span>
          </button>
          <div className="footnote">
            <Keys />
          </div>
        </div>
      </div>
    </div>
  );
};

export default KeyScreen;
